import { useIntl } from 'react-intl';

import UFOSegment from '@atlaskit/react-ufo/segment';
import { Editions } from '@atlassiansox/asc-stargate';

import { useCrossFlowFrontendTouchpoint } from '@/components/cross-flow/touchpoint/use-touchpoint/index';
import { useDarkTheme } from '@/libraries/design/utils/dark-theme-provider';
import { useLocalizedHref } from '@/libraries/web-framework/src/localization/use-localized-href';
import { LogoV3 } from '@/libraries/wpl/foundations/src/logo-v3';
import { ProductPageSubNav } from '@/patterns/global-nav/src/nav-product-page';

const GuardLogoComponent = () => {
	const { isDarkTheme } = useDarkTheme();
	return <LogoV3 brand="guard" type="logo" appearance="brand" lightMode={isDarkTheme} />;
};

export const GuardNav = () => {
	const intl = useIntl();
	const signupLink = 'https://admin.atlassian.com/atlassian-guard';
	const { openCrossFlow } = useCrossFlowFrontendTouchpoint({
		edition: Editions.FREE,
		redirectUrl: signupLink,
	});
	const capabilitiesHref = useLocalizedHref('/software/guard/capabilities');
	const pricingHref = useLocalizedHref('/software/guard/pricing');
	const guidesHref = useLocalizedHref('/software/guard/guide#getting-started');
	const demoHref = useLocalizedHref('/software/guard/demo');

	const links = [
		{
			globalLinksKey: 'capabilities',
			linkText: intl.formatMessage({
				id: 'GuardPageTemplate.navbar.capabilities',
				defaultMessage: 'Capabilities',
			}),
			hasSubnav: false,
			productKey: 'guard',
			href: capabilitiesHref,
		},
		{
			globalLinksKey: 'guides',
			linkText: intl.formatMessage({
				id: 'GuardPageTemplate.navbar.guides',
				defaultMessage: 'Guides',
			}),
			hasSubnav: false,
			productKey: 'guard',
			href: guidesHref,
		},
		{
			globalLinksKey: 'demo',
			linkText: intl.formatMessage({
				id: 'GuardPageTemplate.navbar.demo',
				defaultMessage: 'Demo',
			}),
			hasSubnav: false,
			productKey: 'guard',
			href: demoHref,
		},
		{
			globalLinksKey: 'pricing',
			linkText: intl.formatMessage({
				id: 'GuardPageTemplate.navbar.pricing',
				defaultMessage: 'Pricing',
			}),
			hasSubnav: false,
			productKey: 'guard',
			href: pricingHref,
		},
	];

	return (
		<UFOSegment name="confluence-pt-cfind-1234-GuardNav">
			<ProductPageSubNav
				productLogoUrl="/software/guard"
				productLogo={<GuardLogoComponent />}
				productLogoAriaLabel={intl.formatMessage({
					id: 'GuardPageTemplate.navbar.guard-logo',
					defaultMessage: 'Guard logo',
				})}
				mobileCtaText={intl.formatMessage({
					id: 'GuardPageTemplate.navbar.tryitfree',
					defaultMessage: 'Try it free',
				})}
				navigationTrynowCtaText={intl.formatMessage({
					id: 'GuardPageTemplate.navbar.tryitfree',
					defaultMessage: 'Try it free',
				})}
				mobileCtaUrl={signupLink}
				mobileCtaOnClick={openCrossFlow}
				mobileLogo={<GuardLogoComponent />}
				productPageNavLinks={links}
				navigationTrynowCtaUrl={signupLink}
				navigationTrynowCtaOnClick={openCrossFlow}
				mobileLinksSections={[
					{
						mobileLinkKey: 'mobile-guard',
						mobileLinksProps: links,
					},
				]}
			/>
		</UFOSegment>
	);
};
